import ObjectBuilderInterface from "@/modules/api/object-builder.interface";

import UserInfo from "./user-info.model";

export default class UserInfoFactory
  implements ObjectBuilderInterface<UserInfo> {
  public buildFromJSON(data: { [key: string]: any }): UserInfo {
    const value = new UserInfo(
      data.id,
      data.organization,
      data.email,
      data.firstName,
      data.lastName
    );

    (value as any).fCreatedAt = new Date(data.createdAt);
    (value as any).fUpdatedAt = new Date(data.updatedAt);

    value.isNew = false;

    return value;
  }
}
